import { Box, Typography, Grid, TextField, InputLabel, InputAdornment, IconButton, Button } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import SelectAssetComponent from '../SelectAssetComponent'
import { useUtiles } from '../../../../shared/context/utilesContext'
import { useTaskContext } from '../../../../shared/context/taskContext'
import { useForm, Controller } from 'react-hook-form'
import ClearIcon from '@mui/icons-material/Clear'
export default function AssetFormComponent() {
    const { toogleOpenSilder, locationString } = useUtiles()
    const { control, formState: { errors } } = useForm()
    const theme = useTheme()
    const { task, setTask, stepActive, handleStep, handleStepBack, isUpdateTask } = useTaskContext()



    return (
        <Box>
            <Grid container spacing={2} columns={12}>
                <Grid item size={{ xs: 12 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>Activo</InputLabel>
                    <Typography variant="h6" sx={{ color: theme.palette.text.secondary, fontSize: '12px' }}>
                        Presione sobre el campo para seleccionar un activo
                    </Typography>
                    <Controller
                        control={control}
                        name="asset"
                        rules={{ required: 'El activo es requerido' }}
                        render={({ field }) => (
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Seleccione un activo"
                                disabled={isUpdateTask}
                                InputProps={{
                                    readOnly: true,
                                    endAdornment: task.asset && (
                                        <InputAdornment position="end">
                                            <IconButton 
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setTask({ ...task, asset: null });
                                                }}
                                                size="small"
                                            >
                                                <ClearIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                                onClick={() => {
                                    toogleOpenSilder(
                                        <SelectAssetComponent />,
                                        500,
                                        'Seleccionar activo'
                                    )
                                }}
                                value={ locationString(task.asset)}
                                error={!task.asset}
                                helperText={!task.asset ? 'El activo es requerido' : ''}
                            />
                        )}
                    />
                </Grid>
                <Grid item size={{ xs: 12, md: 6 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>Fecha del incidente</InputLabel>
                    <Typography variant="h6" sx={{ color: theme.palette.text.secondary, fontSize: '12px' }}>
                        Fecha y hora que ocurrió el incidente
                    </Typography>
                    <Controller
                        control={control}
                        name="date_of_incident"
                        render={({ field }) => (
                            <TextField
                                fullWidth
                                variant="outlined"
                                type="datetime-local"
                                value={task.date_of_incident}
                                onChange={(e) => {
                                    setTask({ ...task, date_of_incident: e.target.value })
                                }}
                            />
                        )}
                    />
                </Grid>
                <Grid item size={{ xs: 12, md: 6 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>Solicitado por:</InputLabel>
                    <Typography variant="h6" sx={{ color: theme.palette.text.secondary, fontSize: '12px' }}>
                        Nombre de la persona que solicita el servicio
                    </Typography>
                    <Controller
                        control={control}
                        name="requested_by"
                        render={({ field }) => (
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Ingrese el nombre del solicitante"
                                value={task.requested_by}
                                onChange={(e) => {
                                    setTask({ ...task, requested_by: e.target.value })
                                }}
                            />
                        )}
                    />
                </Grid>
            </Grid>


            <Box sx={{ display: 'flex', justifyContent: 'start', gap: '10px', alignItems: 'center', marginTop: '20px', position: 'absolute', bottom: '20px', left: '20px', right: '20px' }}>
                    <Button
                        variant="contained"
                        onClick={handleStepBack}
                        disabled={stepActive === 1}
                        sx={{
                            borderRadius: '8px',
                            padding: '8px 25px',
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            borderRadius: '50px',
                            transition: 'all 0.2s',
                            "&:hover": {
                                backgroundColor: theme.palette.primary.dark,
                                transform: 'translateY(-2px)'
                            }
                        }}
                    >
                        Anterior
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handleStep}
                        disabled={!task.asset}
                        sx={{
                            borderRadius: '8px',
                            padding: '8px 25px',
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            borderRadius: '50px',
                            transition: 'all 0.2s',
                            "&:hover": {
                                backgroundColor: theme.palette.primary.dark,
                                transform: 'translateY(-2px)'
                            }
                        }}
                    >
                        Siguiente
                    </Button>
                </Box>
        </Box>
    )
}